import { array, number, object, setLocale, string } from 'yup'
import { es } from 'yup-locales'

import { GrupoUnidadMedidaInputProps } from '../interfaces'

setLocale(es)

export const grupoUnidadMedidaRegistroValidator = async (
  input: GrupoUnidadMedidaInputProps,
): Promise<boolean> => {
  const schema = object({
    nombreGrupo: string().required('Debe ingresar el nombre del grupo'),
    codigoUnidadMedidaBase: string().required(
      'Debe ingresar el código de la unidad de medida base',
    ),
    definicion: array()
      .of(
        object({
          codigoUnidadMedida: string().required(
            'Debe ingresar el código de la unidad de medida',
          ),
          cantidadBase: number()
            .moreThan(0, 'La cantidad base debe ser mayor a cero')
            .required('Debe ingresar la cantidad base'),
        }),
      )
      .required('Debe proporcionar la definición de unidades de medida'),
  })

  try {
    await schema.validate(input, { abortEarly: false })
    return true
  } catch (e: any) {
    return false
  }
}

export const GrupoUnidadMedidaRegistroValidationSchema = object({
  nombreGrupo: string().required('Debe ingresar el nombre del grupo'),
  codigoUnidadMedidaBase: string().required(
    'Debe ingresar el código de la unidad de medida base',
  ),
  definicion: array()
    .of(
      object({
        codigoUnidadMedida: string().required(
          'Debe ingresar el código de la unidad de medida',
        ),
        cantidadBase: number()
          .moreThan(0, 'La cantidad base debe ser mayor a cero')
          .required('Debe ingresar la cantidad base'),
      }),
    )
    .required('Debe proporcionar la definición de unidades de medida'),
})
